export const US_TERRITORIES = ['US', 'UM', 'AS', 'GU', 'PR', 'VI'];
const ADDON_COUNTRIES = [...US_TERRITORIES, 'SG', 'HK'];
const SANCTIONED_COUNTRIES = ['CU', 'KP', 'IR', 'SO', 'SS', 'SD', 'SY', 'ZW'];

export const SANCTIONED_COUNTRIES_COMPANIES = SANCTIONED_COUNTRIES;
const SANCTIONED_COUNTRIES_MEMBERS = ['CU', 'KP', 'IR', 'SO', 'SS', 'SD', 'SY', 'ZW'];

const TRAVEL_ONLY_COUNTRIES = [
  ...US_TERRITORIES,
  'AE',
  'CA',
  'CD',
  'SA',
  'PT',
  'PW',
  'PS',
  'IE'
];

export const COUNTRY_RESTRICTIONS = {
  ADDON_COUNTRIES,
  TRAVEL_ONLY_COUNTRIES,
  SANCTIONED_COUNTRIES,
  SANCTIONED_COUNTRIES_COMPANIES,
  SANCTIONED_COUNTRIES_MEMBERS
};

const MEMBER_RESTRICTED_COUNTRIES = [
  ...SANCTIONED_COUNTRIES_MEMBERS,
  ...TRAVEL_ONLY_COUNTRIES
];

// HELPER FUNCTIONS

export const isMemberCountryRestricted = (country) =>
  new Set(MEMBER_RESTRICTED_COUNTRIES).has(country);
